import api from './axios';

export const getEquipamentos = () =>
  api.get('/equipamentos').then((r) => r.data);

export const createEquipamento = (data) =>
  api.post('/equipamentos', data).then((r) => r.data);

export const updateEquipamento = (id, data) =>
  api.patch(`/equipamentos/${id}`, data).then((r) => r.data);
